import posthog from "posthog-js";

const KEY = process.env.REACT_APP_POSTHOG_KEY;
const HOST = process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";

let initialized = false;

export function initAnalytics() {
  if (initialized || !KEY) return;
  posthog.init(KEY, {
    api_host: HOST,
    defaults: "2026-05-30",
    person_profiles: "identified_only",
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
  });
  initialized = true;
}

export function identifyUser(user) {
  if (!initialized || !user?.uid) return;
  posthog.identify(user.uid, {
    email: user.email,
    name: user.displayName,
    provider: user.provider,
  });
}

export function resetUser() {
  if (!initialized) return;
  posthog.reset();
}

export function track(event, props = {}) {
  if (!initialized) return;
  try {
    posthog.capture(event, props);
  } catch {}
}
